import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class YearAnalysis  {
    _originalTypeClassName = "zPMO.BO.YearAnalysis";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
YearAnalysis.translate = translateService;
}
this.Year = null;
this.Licences = null;
this.TotalAmount = null;
this.YearAnalysisKey = null;
this._key = this.YearAnalysisKey = 0; 
}

static translate: TranslateService;
_key: any;
Year:any;
Licences:any;
TotalAmount:any;
private _YearAnalysisKey:any;
get YearAnalysisKey(): any {
    return this._YearAnalysisKey;
  }
set YearAnalysisKey(value: any) {
    this._YearAnalysisKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.YearAnalysisKey == null || $this.YearAnalysisKey == 0;
            }


}